export var Newsletter;
(function (Newsletter) {
    /**
     * Subscribe by email
     */
    let Subscribe;
    (function (Subscribe) {
        Subscribe.path = 'newsletter/subscribe';
    })(Subscribe = Newsletter.Subscribe || (Newsletter.Subscribe = {}));
    /**
     * Unsubscribe
     */
    let Unsubscribe;
    (function (Unsubscribe) {
        Unsubscribe.path = 'newsletter/unsubscribe';
    })(Unsubscribe = Newsletter.Unsubscribe || (Newsletter.Unsubscribe = {}));
    /**
     * Unsuscribe by account
     */
    let UnsubscribeByAccount;
    (function (UnsubscribeByAccount) {
        UnsubscribeByAccount.path = 'newsletter/unsubscribeByAccount';
    })(UnsubscribeByAccount = Newsletter.UnsubscribeByAccount || (Newsletter.UnsubscribeByAccount = {}));
})(Newsletter || (Newsletter = {}));
